// File: client/src/variants/chaos/index.js
// Chaos Chess as a platform plugin — the configurable sandbox.

import rulebook from './rulebook';
import { useChaosRuntime, CHAOS_DEFAULTS } from './useChaosRuntime';

const chaosVariant = {
  id: 'chaos',
  name: 'Chaos Chess',
  tagline: 'Build your own variant — toggle events, shrinking, gravity, meteors.',
  icon: '🌪️',
  accent: 'from-indigo-600 to-slate-800',
  supportedGameTypes: ['ai', 'local'],
  order: 8,
  rulebook,
  useRuntime: useChaosRuntime,
  defaultSettings: CHAOS_DEFAULTS,
  // Declarative schema the setup UI can render generically (booleans as toggles).
  // Applied via config.settings; defaults are used when the UI doesn't override.
  settingsSchema: [
    { key: 'randomEvents', label: 'Random events', type: 'boolean' },
    { key: 'shrink', label: 'Shrinking board (Royale)', type: 'boolean' },
    { key: 'gravity', label: 'Periodic gravity', type: 'boolean' },
    { key: 'meteor', label: 'Periodic meteors', type: 'boolean' },
  ],
};

export default chaosVariant;
